import { track } from './data/track';
import './styles/app.css';
import { repo } from './data/repo';
import { detectLocale, setLocale } from './i18n';
import { installAudioUnlock, sfx } from './audio/sfx';
import { go, refresh, registerActions, startRouter, currentScreen } from './ui/router';
import { afterSignIn, hasPendingDraft } from './ui/screens/onboarding';
import './ui/screens/counting';
import './ui/screens/stats';
import './ui/screens/start';
import { handleCheckoutReturn, showLegal } from './ui/screens/settings';
import { bellyFrontPoint } from './ui/bellyHost';

registerActions({ legal: el => showLegal(el.dataset.doc as 'terms' | 'privacy') });

async function boot() {
  setLocale(repo.locale ?? detectLocale());
  startRouter();
  installAudioUnlock();
  await repo.init();
  track.once('first_open'); track.daily('app_open');
  sfx.setEnabled(repo.profile?.soundOn ?? true);

  // Re-render the open screen when data changes (sync finished, entitlement updated...)
  const NEEDS_PROFILE = new Set(['home', 'session', 'done', 'stats', 'profile', 'paywall', 'hospital']);
  let lastUser = repo.user?.id;
  repo.subscribe(() => {
    // signed out / account deleted / signed in elsewhere: never render a screen without its data
    if (!repo.profile && NEEDS_PROFILE.has(currentScreen()?.id ?? '')) {
      go('start', { replace: true });
      return;
    }
    if (repo.user?.id !== lastUser) {
      lastUser = repo.user?.id;
      // returning from Google sign-in (redirect) or signed in on another tab
      if (repo.user && ['account', 'login'].includes(currentScreen()?.id ?? '')) { afterSignIn(); return; }
    }
    refresh();
  });

  if (repo.profile) go('home', { replace: true });   // signed in, demo, or trying it before signing in
  else if (repo.user && hasPendingDraft()) afterSignIn();
  else if (repo.user) go(repo.profile ? 'home' : 'how', { replace: true });
  else go('start', { replace: true });   // first visit: tap the belly straight away, no forms

  void handleCheckoutReturn();

  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    navigator.serviceWorker.register('/sw.js').catch(err => console.warn('[sw]', err));
  }
}

void boot();

// Read-only hook for automated UI tests: where on screen the bump is. Exposes no data.
(window as unknown as { __bk: unknown }).__bk = { bellyFront: bellyFrontPoint };
